// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/DevicesFranquias_SetupDeviceResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for POST /config/devices_franquias/setup_device
 *
 * Returns the QR code (base64 image or raw code string) the user scans to
 * pair the device, plus a confirmation message.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface DevicesFranquias_SetupDeviceResponseDados {
qrcode: string
message: string
}

export type DevicesFranquias_SetupDeviceResponse = ApiResponse<DevicesFranquias_SetupDeviceResponseDados>;

registerResponseContract('DevicesFranquias_SetupDeviceResponse', {
  qrcode:  { type: 'string',  required: true },
  message: { type: 'string',  required: true },
})
